module.exports = __webpack_public_path__ + "img/exchange_bg.78a3d412.png";